export default __webpack_public_path__ + "assets/708f39b6081ee6125016aae60a12675d.jpeg";